import { Routes } from '@angular/router';
import { BiometricLoginComponent } from './components/biometric-login/biometric-login.component';
import { AdminPanelComponent } from './components/admin-panel/admin-panel.component';
import { AppComponent } from './app.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  { 
    path: 'login', 
    component: BiometricLoginComponent 
  },
  { 
    path: 'app', 
    component: AppComponent,
    canActivate: [authGuard]
  },
  { 
    path: 'admin', 
    component: AdminPanelComponent,
    canActivate: [authGuard]
  },
  { 
    path: '', 
    redirectTo: '/app', 
    pathMatch: 'full' 
  }
];
